import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { Grid, Typography } from '@mui/material';

const useStyles = makeStyles()((theme) => ({
  root: {
    padding: theme.spacing(4),
  },
  content: {
    paddingTop: 150,
    textAlign: 'center',
  },
}));

const NotAuthorized = () => {
  const { classes } = useStyles();

  return (
    <div className={classes.root}>
      <Grid container justifyContent="center" spacing={4}>
        <Grid item lg={6} xs={12}>
          <div className={classes.content}>
            <Typography variant="h1">403: Você não está autorizado a acessar está página.</Typography>
            <Typography variant="subtitle2">
              Você pode ter chegado aqui por engano ou por acidente. Em caso de dúvida contate a equipe de
              suporte.
            </Typography>
          </div>
        </Grid>
      </Grid>
    </div>
  );
};

export default NotAuthorized;
